// extracted by mini-css-extract-plugin
module.exports = {"timer-container":"timer_timer-container__2tIix","timer-content":"timer_timer-content__3vl5I","timer-content-ar":"timer_timer-content-ar__1qwxJ"};